import React, { useState, useCallback, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useFormContext } from 'react-hook-form'
import { Col, Form } from 'react-bootstrap'

import { useVerificador, usePrecarga, useApiCall } from './Hooks'
import CargandoDatosLoader from 'components/CargandoDatosLoader'
import { mainRequest } from 'utils/requests'
import Sucursales from './Sucursales'

function DatosActividadComercial() {
  const { trigger, getValues, formState, register, watch } = useFormContext()
  const location = useLocation()
  const [content, setContent] = useState({})
  const [sucursalesExternas, setSucursalesExternas] = useState(false)

  const tiene_sucursales = watch('tiene_sucursales_externas')

  useEffect(() => {
    setSucursalesExternas(tiene_sucursales === 'true')
  }, [setSucursalesExternas, tiene_sucursales])

  const storeData = useCallback(() => {
    if (location?.state?.visualizarDatos)
      return new Promise((resolve, _) => resolve(true)).then((res) => res)

    if (!formState.isValid) {
      trigger()
      return false
    }

    return mainRequest('/ddjj/alta/api/store-actividades', {
      method: 'POST',
      body: JSON.stringify(getValues())
    }).then(({ status, content }) => status === 200 && content?.success)
  }, [formState.isValid, trigger, getValues, location])

  useVerificador(storeData, true)
  const [loadingApi] = useApiCall('/ddjj/alta/api', setContent)
  const [loadingPrecarga] = usePrecarga(
    '/ddjj/alta/api/datos-actividades',
    'datos_actividades'
  )

  return (
    <>
      <CargandoDatosLoader cargando={loadingApi || loadingPrecarga}>
        <h6 className="text-muted text-normal text-uppercase">
          Datos de la actividad comercial en Berisso
        </h6>
        <hr className="mb-4" />

        <Sucursales
          actividades={content.actividades}
          actividadesiibb={content.actividadesiibb}
          show={true}
          name="sucursales"
        />

        <input
          style={{ display: 'none' }}
          name="tiene_sucursales_externas"
          defaultValue={sucursalesExternas}
          ref={register({ required: false })}
        />

        <Form.Row>
          <Col md={6}>
            <Form.Group>
              <Form.Label as="legend" column>
                ¿Posee sucursales en la provincia de Buenos Aires?
              </Form.Label>

              <Form.Row className="justify-content-around px-5 py-2">
                <Form.Check
                  type="radio"
                  label="Sí"
                  checked={sucursalesExternas}
                  onChange={(e) => setSucursalesExternas(e.target.checked)}
                  disabled={location?.state?.visualizarDatos}
                />
                <Form.Check
                  type="radio"
                  label="No"
                  checked={!sucursalesExternas}
                  onChange={(e) => {
                    setSucursalesExternas(!e.target.checked)
                  }}
                  disabled={location?.state?.visualizarDatos}
                />
              </Form.Row>
            </Form.Group>
          </Col>
        </Form.Row>

        <Sucursales
          show={sucursalesExternas}
          name="externas"
          actividades={content.actividades}
          actividadesiibb={content.actividadesiibb}
        />
      </CargandoDatosLoader>
    </>
  )
}

export default DatosActividadComercial
